import { IELTS_SCORE_SELECT_MODEL } from "../Models/CoursesModel";

export default function IeltsScore({ CourseForm, handleFormChange }) {
  return (
    <select
      type="number"
      className="form-control"
      placeholder="IELTS Score"
      name={"IELTS_Score"}
      value={CourseForm.IELTS_Score}
      onChange={(e) => handleFormChange(e)}>
      <option value="">Select IELTS Score</option>
      {IELTS_SCORE_SELECT_MODEL.map((el, i) => (
        <option key={i + Math.random()} value={el}>
          {el}
        </option>
      ))}
    </select>
  );
}
